import type { Booking, BusinessDetail } from '../api/schemas';
import { serviceName } from './useBusiness';

/**
 * The words a booking row is made of. Kept out of the components so the same
 * resolution serves the agenda, the detail page, and their tests.
 */

/** The customer leads when the API knows them; the service otherwise. */
export function bookingTitle(booking: Booking, business: BusinessDetail | undefined): string {
  return customerNameOf(booking) ?? serviceName(business, booking.serviceId);
}

/** Service, duración, personas, quién atiende, oferta: only the ones that apply. */
export function bookingFacts(booking: Booking, business: BusinessDetail | undefined): string[] {
  const facts: string[] = [];
  if (customerNameOf(booking)) facts.push(serviceName(business, booking.serviceId));
  facts.push(`${booking.durationMin} min`);
  if (booking.partySize !== undefined && booking.partySize > 1) {
    facts.push(`${booking.partySize} personas`);
  }
  const staff = staffNameOf(booking, business);
  if (staff) facts.push(staff);
  if (booking.offer) facts.push(booking.offer.title);
  return facts;
}

export function staffNameOf(
  booking: Booking,
  business: BusinessDetail | undefined,
): string | undefined {
  if (!booking.staffId) return undefined;
  return business?.staff.find((member) => member.id === booking.staffId)?.name;
}

export function customerNameOf(booking: Booking): string | undefined {
  const name = booking.customerName;
  return typeof name === 'string' && name.trim() !== '' ? name : undefined;
}
